export default defineNuxtRouteMiddleware((to, from) => {
  useDPrint('中间件触发')
})
